import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const options = { withCredentials: true };

@Injectable({
	providedIn: 'root',
})
export class RestService {
	constructor(private http: HttpClient) {}

	GET(url: string): Observable<any> {
		return this.http.get(url, options).pipe(
			map((response: any) => {
				return response;
			})
		);
	}

	POST(url: string, data): Observable<any> {
		return this.http.post(url, data, options).pipe(
			map((response: any) => {
				return response;
			})
		);
	}

	PUT(url: string, data): Observable<any> {
		return this.http.put(url, data, options).pipe(
			map((response: any) => {
				return response;
			})
		);
	}

	DELETE(url: string, data: any = {}): Observable<any> {
		const customOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
			body: data,
			withCredentials: true,
		};
		return this.http.delete(url, customOptions).pipe(
			map((response: any) => {
				return response;
			})
		);
	}
}
